app.controller("letterTableController", [
	"$scope",
	"ClinicLettersAPI",
	"$modal",
	"NgTableParams",
	"PatientAPI",
	"CurrentPatient",
	"$state",
	"Session",
	"$timeout",
	"$filter",
	"$mdDialog",
	"$q",
	function ($scope, ClinicLettersAPI,$modal,NgTableParams,PatientAPI,CurrentPatient,$state,Session,$timeout,$filter,$mdDialog,$q) {
		this.$onInit = function () {
			fetchUncompletedLetters();
			$scope.currentUserId = parseInt(Session.user.id);
		};
		$scope.API = ClinicLettersAPI;
		$scope.PA = PatientAPI;
		$scope.CP = CurrentPatient;
		$scope.completedLetters = [];
		$scope.uncompletedLetters = [];
		$scope.$mdDialog = $mdDialog;

		function getLettersPage(isCompleted, pageIndexes) {
			return $scope.API
				.getLetters(isCompleted, pageIndexes)
				.then(function (response) {
					var clinicalLettersList = angular.copy(response.data.clinical_letters);
					var nextPageIndexes = angular.copy(response.data.page_indexes);

					return {
						clinicalLettersList: clinicalLettersList,
						nextPageIndexes: nextPageIndexes
					};
				})
				.catch(function (error) {
					showGenericErrorModal();
					return $q.reject(error);
				});
		}

		function fetchCompleteLetters() {
			$scope.API.isProcessing = true;
			// Refetched after every draft delete, so start from empty rather than appending again.
			$scope.completedLetters = [];

			var initialPageIndexes = null;
			function recursivelyFetch(pageIndexes) {
				return getLettersPage(true, pageIndexes)
					.then(function (fetchResult) {
						$scope.completedLetters = $scope.completedLetters.concat(fetchResult.clinicalLettersList);

						if (fetchResult.nextPageIndexes && fetchResult.nextPageIndexes.length > 0) {
							return recursivelyFetch(fetchResult.nextPageIndexes);
						}
					});
			}

			recursivelyFetch(initialPageIndexes)
				.then(function () {
					$scope.tableCompleteParams = new NgTableParams(
						{ count: 10 },
						{
							counts: [],
							dataset: $scope.completedLetters
						}
					);
					fetchTemplate();
				})
				.finally(function () {
					$scope.API.isProcessing = false;
				});
		}

		function fetchUncompletedLetters() {
			$scope.API.isProcessing = true;
			$scope.uncompletedLetters = [];
			var initialPageIndexes = null;
			function recursivelyFetch(pageIndexes) {
				return getLettersPage(false, pageIndexes)
					.then(function (fetchResult) {
						$scope.uncompletedLetters = $scope.uncompletedLetters.concat(fetchResult.clinicalLettersList);

						if (fetchResult.nextPageIndexes && fetchResult.nextPageIndexes.length > 0) {
							return recursivelyFetch(fetchResult.nextPageIndexes);
						}
					});
			}

			recursivelyFetch(initialPageIndexes)
				.then(function () {
					$scope.tableUncompleteParams = new NgTableParams(
						{ count: 10 },
						{
							counts: [],
							dataset: $scope.uncompletedLetters.filter(t=>!t.is_deleted)
						}
					);
					fetchCompleteLetters();
				})
				.finally(function () {
					$scope.API.isProcessing = false;
				});
		}

		function showGenericErrorModal() {
			if($scope.serverErrorModal){
				$scope.serverErrorModal.hide();
			}
			$scope.serverErrorModal = $modal({
				scope: $scope,
				templateUrl: "app/src/views/templates/modal.server-error.tpl.html",
				show: true,
				title: "CatTrax has encountered an error",
			});
		}

		$scope.selectedLetter = null;
		$scope.forwardPatientDashboard = function (letter) {
			$scope.PA.getPatient(letter.patient_id).then(
				function (resp) {
					selectPatient(resp.data);
				},
				function (error) {
					showGenericErrorModal();
				}
			);
		};

		function selectPatient(patient) {
			if ($scope.CP.patientBackup) {
				$scope.patientBackup = angular.copy($scope.CP.patientBackup);
			}
			$scope.CP.clearPatient();

			$timeout(function () {
				$scope.CP.setPatient(patient);
				if (!$scope.CP.patientIsMine) {
					// Launch the new standalone transfer modal
					$modal({
						controller: "patientTransferController",
						templateUrl: "app/src/views/templates/modal.patient-transfer-flow.tpl.html",
						show: true,
						backdrop: "static",
						resolve: {
							patientId: function () {
								return patient.id;
							},
							onSuccess: function () {
								return function (updatedPatient) {
									$scope.CP.setPatient(updatedPatient);
									if ($scope.selectedLetter) {
										$state.go("patient-dashboard").then(() => {
											goToLetterSreen($scope.selectedLetter.clinical_letter_id);
										});
									} else {
										$state.go("patient-dashboard");
									}
								};
							},
							onCancel: function () {
								return function () {
									// Restore the backup if they cancel
									if ($scope.patientBackup) {
										$scope.CP.setPatient($scope.patientBackup);
									} else {
										$scope.CP.clearPatient();
									}
								};
							}
						}
					});
				} else {
					if ($scope.selectedLetter) {
						$state.go("patient-dashboard").then(() => {
							goToLetterSreen($scope.selectedLetter.clinical_letter_id);
						});
					} else {
						$state.go("patient-dashboard");
					}
				}
			}, 50);
		}

		$scope.goToDashboard = function (e, letter) {
			e.preventDefault();
			e.stopPropagation();
			$scope.selectedLetter = null;
			$scope.forwardPatientDashboard(letter);
		};

		$scope.goToLetterDetails = function(letter) {
			$scope.selectedLetter = letter;
			$scope.forwardPatientDashboard(letter);
		}

		function goToLetterSreen(clinical_letter_id) {
			setTimeout(() => {
				$state.go("clinic-letter", { id: clinical_letter_id });
			}, 0);
		}

		$scope.templateList = [];

		function fetchTemplate() {
			$scope.API.isProcessing = true;
			$scope.API.fetchTemplate()
				.then(
					function (resp) {
						$scope.templateList = angular.copy(resp.data);

						$scope.tableTemplateParams = new NgTableParams(
							{
								count: 10,
							},
							{
								counts: [],
								dataset: $scope.templateList
							}
						);
					},
					function (e) {
						console.error("Fetch templates failed", e && e.status);
					}
				)
				.then(() => ($scope.API.isProcessing = false));
		}

		$scope.createNewTemplate = function() {
			setTimeout(() => {
				$state.go("clinic-letter", { createTemplate: true });
			}, 0);
		}

		$scope.deleteTemplate = function (templateId) {
			$scope.API.isProcessing = true;

			$scope.API.deleteTemplate(templateId)
				.then(
					function () {
						// showGenericSuccessModal("Delete template successfully", true);
						fetchTemplate();
					},
					function () {
						showGenericErrorModal();
					}
				)
				.then(() => ($scope.API.isProcessing = false));
		};

		$scope.editTemplate = function (templateId) {
			setTimeout(() => {
				$state.go("clinic-letter", { templateId });
			}, 0);
		}

		$scope.formatDate = function (date) {
			//UTC to local
			return $filter("date")(moment.utc(date).toDate(), "dd/MM/yyyy");
		 }

		 $scope.deleteLetter = function (e,letter) {
			e.preventDefault();
			e.stopPropagation();
			if (letter.created_by_user_id !== $scope.currentUserId) {
				return;
			}
			$scope.negativeButton = null;

			$scope.generalModal = $modal({
				scope: $scope,
				templateUrl: "app/src/views/templates/modal.general.tpl.html",
				show: true,
				title: "Delete Clinic Letter",
				content: "Are you sure you want to delete this clinic letter? It can’t be undone.",
				backdrop: true,
				keyboard: false,
			});

			$scope.onGeneralClick = () => {
				if ($scope.generalModal) {
					$scope.generalModal.hide();
					$scope.negativeButton = null;
				}
	
				$scope.API.isProcessing = true;
				$scope.API.deleteLetter(letter.patient_id, letter.clinical_letter_id)
					.then(
						function (resp) {
							fetchUncompletedLetters();
						},
						function (error) {
							showGenericErrorModal();
						}
					)
					.then(() => ($scope.API.isProcessing = false));
			};









		 }



	},
]);
